// src/components/CustomSnackbar.js
import React from "react";

const getStyle = (variant) => {
  const base = {
    borderRadius: "15px",
    fontSize: "1rem",
    padding: "16px 20px",
    marginBottom: "8px",
    color: "#000",
    backdropFilter: "blur(10px)",
    boxShadow: "0 0 12px rgba(0, 0, 0, 0.1)",
  };

  const variants = {
    success: {
      backgroundColor: "#deffe8",
      borderLeft: "4px solid #17ea80",
    },
    error: {
      backgroundColor: "#ffd1d0",
      borderLeft: "4px solid #e91a17",
    },
  };

  return { ...base, ...variants[variant] };
};

const CustomSnackbar = React.forwardRef(({ message, variant }, ref) => {
  return (
    <div style={getStyle(variant)} ref={ref}>
      {message}
    </div>
  );
});

export default CustomSnackbar;
